module.exports = __webpack_public_path__ + "static/media/Participated_Events_Banner_EventCount.17d12165.png";